import { RiFingerprintLine } from '@remixicon/react';

import EmptyLayout from '@/layouts/empty';
import LoginForm from '@/components/forms/FormLogin';

export default function DocsPage() {
  return (
    <EmptyLayout>
      <section className="flex min-h-[calc(100vh-4rem)] w-full flex-col items-center justify-center py-8 md:py-10">
        <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-xl ring-1 ring-black/5 dark:bg-neutral-900">
          <RiFingerprintLine className="text-default-400 pointer-events-none mx-auto mb-4 size-20" />
          <div className="mb-6 text-center">
            <h2 className="mt-2 text-lg text-gray-500 dark:text-gray-400">Please enter your credentials to continue</h2>
          </div>
          <LoginForm />
        </div>
      </section>
    </EmptyLayout>
  );
}
